import { CONNECTION_PAYPAL, CONNECTION_STRIPE } from '@/domain/connections';
import { axiosUserRequest } from '@/helpers/authservice/axios';
import { EventBus } from '@/services/event-bus';
import store from '@/state/store.js';

export const state = {
    connections: [],
};

export const getters = {
    getById(state) {
        return id => {
            return state.connections.find(connection => connection.id === id);
        }
    }
};

export const mutations = {
    set(state, data) {
		state.connections = data;
	},

    clear(state) {
        state.connections = [];
    }
};

export const actions = {
    getListing({ commit }) {
        return axiosUserRequest({ method: 'get', url: `/v1/connections`}).then(({ data }) => {
			commit('set', data.items);
		});
    },

    create(state, data) {
        return axiosUserRequest({ method: 'post', url: `/v1/connections`, data });
    },

    createStripeConnectionLink() {
        return axiosUserRequest({
			method: 'post', url: `/v1/connections/stripe/url`, data: {
				redirect_uri: `${process.env.VUE_APP_URL}/oauth/stripe`
			}
		});
    },

    createPayPalConnectionLink() {
		return axiosUserRequest({ method: 'post', url: `/v1/connections/paypal/url`, data: {
			redirect_uri: `https://app.tipsme.online/oauth/paypal`
		}});
	},

    createStripeConnection(state, code, profileId) {
		return axiosUserRequest({
			method: 'post', url: `/v1/connections`, data: {
				profile_id: profileId,
                platform: CONNECTION_STRIPE,
				code
			}
		});
	},

    createPayPalConnection(state, code, profileId) {
		return axiosUserRequest({ method: 'post', url: `/v1/connections`, data: {
			profile_id: profileId,
            platform: CONNECTION_PAYPAL,
			code
		}});
	},

    confirm(state, { connectionId, code }) {
        return axiosUserRequest({ method: 'post', url: `/v1/connections/${connectionId}/confirm`, data: { code }});
    },

    delete(state, id) {
        return axiosUserRequest({ method: 'delete', url: `/v1/connections/${id}` });
    },

    clear({ commit }) {
        commit('clear');
    }
};

EventBus.$on('logout', () => {
    store.dispatch('connection/clear');
});
